module.exports = __webpack_public_path__ + "img/ic24Comment.201078aa.svg";